.footer-panel {
  --footer-panel-padding: 0.25rem;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 0.5rem;
  padding: var(--footer-panel-padding);
  border-radius: 50vh;

  border: 1px solid var(--color-border-primary);
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.10);

  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  background-color: color-mix(in srgb, var(--color-bg-secondary) 71%, transparent);
}

.button-grow {
  transition: all 0.2s ease-in-out;
}

.button-grow:hover {
  transform: scale(1.05);
}
